<app-breadcrumb *ngIf="!(dialogRef)" master="Struktura sieci" parentName="Umowy" name="Dodaj"></app-breadcrumb>
<div class="contract-add-container" [formGroup]="contractForm" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row" fxLayoutGap="15px" *ngIf="!dialogRef">
    <ng-container ><button (click)="sendForm()" [class.spinner]="processingRequest" [disabled]="processingRequest || !enableSaveButton" mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button></ng-container>
<!--    <ng-container *ngIf="contractForm.get('partner').value && contractType?.key === CONTRACT_TYPE_SELF_BILLING && !getListOfVatButton"><button (click)="getListOfVat()"  mat-stroked-button color="primary" matTooltip="Wykaz Podatnikow Vat" class="active"><mat-icon>send</mat-icon><span> Pobierz dane z rejestru podatników VAT</span></button></ng-container>-->
    <button [routerLink]="'/ofwca'" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">
    <div fxLayout="column" [fxFlex]="dialogRef ? '100' : '50'" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane umowy</h3>
            </div>
            <div fxLayout="row" *ngIf="!dialogRef">
              <div fxFlex="100">
                <app-dict
                  [label]="'Strona umowy'" [dictType]="'contract_owner'"
                  [control]="ownerControl"
                  [onlyKeys]=[CONTRACT_OWNER_PARTNER]
                  [required]="true"
                  [multiple]="false"
                  [disable]="true"
                ></app-dict>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50" *ngIf="partnerObject">
<!--                <app-dict *ngIf="!requiredOfwca && !requiredPartner"-->
<!--                  [label]="'Rodzaj umowy'" [dictType]="'contract_type'"-->
<!--                  [control]="typeControl"-->
<!--                  [required]="true"-->
<!--                  [multiple]="false"-->
<!--                  (selectedDict)="contractTypeChanged($event)"-->
<!--                ></app-dict>-->

                <app-dict *ngIf="requiredOfwca"
                          [label]="'Rodzaj umowy'" [dictType]="'contract_type'"
                          [control]="typeControl"
                          [required]="true"
                          [multiple]="false"
                          [onlyKeys]="OFWCA_TYPES"
                          (selectedDict)="contractTypeChanged($event)"
                ></app-dict>

                <app-dict *ngIf="requiredPartner && !this.partnerObject"
                          [label]="'Rodzaj umowy'" [dictType]="'contract_type'"
                          [control]="typeControl"
                          [required]="true"
                          [multiple]="false"
                          [onlyKeys]="PARTNER_TYPES"
                          (selectedDict)="contractTypeChanged($event)"
                ></app-dict>

                <app-dict *ngIf="requiredPartner && this.partnerObject.nip"
                          [label]="'Rodzaj umowy'" [dictType]="'contract_type'"
                          [control]="typeControl"
                          [required]="true"
                          [multiple]="false"
                          [onlyKeys]="PARTNER_TYPES"
                          [skipKeys]="[CONTRACT_TYPE_LEAD_COMPLETE_PACKAGE, CONTRACT_TYPE_LEAD_ONLY_HEALTH]"
                          (selectedDict)="contractTypeChanged($event)"
                ></app-dict>
              </div>

              <div fxFlex="50" *ngIf="!partnerObject">

                <app-dict
                  [label]="'Rodzaj umowy'" [dictType]="'contract_type'"
                  [control]="typeControl"
                  [required]="true"
                  [multiple]="false"
                  [onlyKeys]="TYPES_ALL"
                  (selectedDict)="contractTypeChanged($event)"
                ></app-dict>
              </div>

              <div fxFlex="50">
                <app-datepicker
                  label="Data zawarcia"
                  placeholder="2000-01-01"
                  [required]="true"
                  [control]="concludeDateControl"
                  [minDate]="limitDates ? todayDate : null"
                  [maxDate]="limitDates ? maxDate : null"
                  [dateFilter]="limitDates ? weekendsDatesFilter : null"
                ></app-datepicker>
              </div>

            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50" *ngIf="!nonePartnershipContractType">
                <app-dict
                  [label]="'Firma'" [dictType]="'company'"
                  [control]="companyControl"
                  [required]="true"
                  [multiple]="false"
                  [skipKeys]="[COMPANY_MULTISFERA]"
                ></app-dict>
              </div>
              <div fxFlex="50" *ngIf="nonePartnershipContractType ">
                <app-dict
                  [label]="'Firma'" [dictType]="'company'"
                  [control]="companyControl"
                  [required]="true"
                  [multiple]="false"
                ></app-dict>
              </div>
<!--              <div fxFlex="50" *ngIf="nonePartnershipContractType && contractType?.key === CONTRACT_TYPE_MANDATE ">-->
<!--                <app-dict-->
<!--                  [label]="'Firma'" [dictType]="'company'"-->
<!--                  [control]="companyControl"-->
<!--                  [required]="true"-->
<!--                  [multiple]="false"-->
<!--                ></app-dict>-->
<!--              </div>-->

              <div fxFlex="50">
                <mat-form-field fxFlex="100">
                  <mat-label>Numer</mat-label>
                  <input matInput placeholder="Numer" formControlName="number" [required]="required">
                  <mat-error *ngIf="contractForm.get('number').hasError('required')">To pole jest wymagane</mat-error>
                  <mat-error *ngIf="contractForm.get('number').hasError('backendError')">
                    {{contractForm.get('number').getError('backendError')}}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px" *ngIf="commissionTableRequired">
              <div fxFlex="100">
                <app-dict-commission-tables
                  label="Tabela prowizyjna"
                  [control]="commissionTableControl"
                  [commissionTables]="commissionTables"
                  [companyId]="companyControl.value"
                  [contractTypeId]="typeControl.value"
                  [required]="commissionTableRequired"
                ></app-dict-commission-tables>

              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <mat-slide-toggle color="accent" formControlName="numberGenerate">Generuj numer automatycznie</mat-slide-toggle>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="partnershipContractType">
              <div fxFlex="100">
                <mat-slide-toggle color="accent" formControlName="customRates">Stawki niestandardowe </mat-slide-toggle>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="partnershipContractType">
              <div fxFlex="100">
                <mat-slide-toggle color="accent" [formControl]="assignedContractControl">Umowa przepisywana </mat-slide-toggle>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="customTermsContractType">
              <div fxFlex="100">
                <mat-slide-toggle color="accent" formControlName="customTerms">Niestandardowe zapisy w umowie </mat-slide-toggle>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="assignedContractControl.value">
              <div fxFlex="100">
                <app-dict-partners
                  fxFlex="100" label="Partner, z którego przepisujemy umowę"
                  [control]="assignedPartnerControl" [required]="true"
                ></app-dict-partners>
              </div>
            </div>

            <div fxLayout="row" *ngIf="dialogRef && requiredParentContract && showPartnershipContractSelect" class="parent-contract-control">
              <div fxFlex="100">
                <app-dict-contracts fxFlex="100" label="Umowa Współpracy" [control]="parentContractControl" [required]="false" [contracts]="contracts"></app-dict-contracts>
              </div>
            </div>
            <div fxLayout="row" *ngIf="dialogRef">
              <div fxFlex="100">
                <app-partner-facility-select
                  [control]="facilityControl" [partnerId]="partnerControl.valueChanges"
                  [required]="true" fxFlex="100"
                  fxLayoutAlign="space-around end"
                  label="Placówka"
                ></app-partner-facility-select>
              </div>
            </div>

            <div fxLayout="row" *ngIf="dialogRef">
              <mat-form-field fxFlex="100">
                <mat-label>Uwagi</mat-label>
                <textarea formControlName="note" matInput placeholder="Uwagi"></textarea>
              </mat-form-field>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="contractType?.key === CONTRACT_TYPE_SELF_BILLING || contractType?.key === CONTRACT_TYPE_PARTNERSHIP  || contractType?.key === CONTRACT_TYPE_PROFIT" fxLayoutGap="15px">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <div fxFlex="50">
                <ng-container *ngIf="contractType?.key === CONTRACT_TYPE_SELF_BILLING">
                  <h3 >Dane umowy na samofakturowanie</h3>
                </ng-container>
                <ng-container *ngIf="contractType?.key === CONTRACT_TYPE_PARTNERSHIP || contractType?.key === CONTRACT_TYPE_PROFIT">
                  <h3 >Dane do zestawienia prowizyjnego</h3>
                </ng-container>
              </div>
            </div>

            <div fxLayout="row">
              <mat-form-field fxFlex="100">
                <mat-label>Email</mat-label>
                <input matInput placeholder="adres@asf.com.pl" [formControl]="selfBillingEmailControl" [required]="true">
              </mat-form-field>
            </div>

            <div fxLayout="row">
              <mat-form-field fxFlex="100">
                <mat-label>Numer telefonu</mat-label>
                <input matInput placeholder="+48 500 200 300" [formControl]="selfBillingPhoneControl" [required]="true" prefix="+48" mask=" 000 000 000">
              </mat-form-field>
            </div>

            <div fxLayout="row">
              <mat-form-field fxFlex="100">
                <mat-label>Numer rachunku bankowego</mat-label>
                <input
                  prefix="PL" mask=" 00 0000 0000 0000 0000 0000 0000" [dropSpecialCharacters]="false"
                  matInput placeholder="PL 27 1140 2004 0000 3002 0135 5387"
                  [formControl]="selfBillingAccountNumberControl">
                <mat-error *ngIf="selfBillingAccountNumberControl.hasError('invalidIban')">Podaj prawidłowy IBAN</mat-error>
                <mat-error *ngIf="selfBillingAccountNumberControl.getError('vatPayerControl')">Numer rachunku bankowego jest inny niż w rejestrze płatników VAT</mat-error>
              </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutGap="15px" *ngIf="vatTaxpayersAccountNumber.length > 0">
              <div fxFlex="100">
                <app-detail header="Numer rachunku bankowego zgłoszony do rejestru płatników VAT">
                  <mat-chip-list>
                    <ng-container *ngFor="let tag of vatTaxpayersAccountNumber; let last = last">
                      <mat-chip   color="accent" (click)="copyMessage(tag)">
                        <span>{{tag | mask: '00 0000 0000 0000 0000 0000 0000'}}</span>

                       </mat-chip>
                    </ng-container>
                  </mat-chip-list>
                </app-detail>
              </div>
            </div>


            <div fxLayout="row"  *ngIf="contractType?.key === CONTRACT_TYPE_SELF_BILLING">
              <mat-slide-toggle [formControl]="selfBillingVatPayerControl" color="accent">Zarejestrowany jako płatnik VAT</mat-slide-toggle>
            </div>

            <div fxLayout="row"  *ngIf="contractType?.key === CONTRACT_TYPE_SELF_BILLING">
              <mat-slide-toggle [formControl]="selfBillingActiveVatPayerControl" color="accent">Płatnik VAT czynny</mat-slide-toggle>
            </div>

            <div fxLayout="row"  *ngIf="contractType?.key === CONTRACT_TYPE_SELF_BILLING">
              <mat-slide-toggle [formControl]="selfBillingCheckoutMethodControl" color="accent">Metoda kasowa</mat-slide-toggle>
            </div>

          </mat-card>
        </div>
      </div>

    </div>

    <div *ngIf="!dialogRef" fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Relacje</h3>
            </div>

            <div fxLayout="row" *ngIf="requiredOfwca">
              <div fxFlex="100">
                <app-dict-ofwcas fxFlex="100" label="OFWCA" [control]="ofwcaControl" [required]="true"></app-dict-ofwcas>
              </div>
            </div>

            <div fxLayout="row" *ngIf="requiredPartner">
              <div fxFlex="100" *ngIf="nonePartnershipContractType" >
              <app-dict-partners
                fxFlex="100" label="Partner"
                [control]="partnerControl" [required]="true"
                [filterFormOfBusiness]="nonePartnershipTypeId"
                (selectedPartner)="partnerChanged($event)"
              ></app-dict-partners>
            </div>

              <div fxFlex="100" *ngIf="!nonePartnershipContractType">
                <app-dict-partners
                  fxFlex="100" label="Partner"
                  [control]="partnerControl" [required]="true"
                  (selectedPartner)="partnerChanged($event)"
                ></app-dict-partners>
              </div>
            </div>

            <div fxLayout="row" >
              <div fxFlex="100">
                <app-dict-contracts
                  fxFlex="100" label="Umowa Współpracy"
                  [control]="parentContractControl"
                  [required]="false" [contracts]="contracts"
                ></app-dict-contracts>
              </div>
            </div>
            <div fxLayout="row" >
              <div fxFlex="100">
                <app-partner-facility-select
                  label="Placówka" fxFlex="100"
                  [required]="true" fxLayoutAlign="space-around end"
                  [control]="facilityControl"
                  [partnerId]="partnerControl.valueChanges"
                ></app-partner-facility-select>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="!dialogRef">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Uwagi</h3>
            </div>

            <div fxLayout="row">
              <mat-form-field fxFlex="100">
                <mat-label>Uwagi</mat-label>
                <textarea formControlName="note" matInput placeholder="Uwagi"></textarea>
              </mat-form-field>
            </div>

          </mat-card>
        </div>
      </div>

    </div>

    <ng-container *ngIf="dialogRef">
      <input type="hidden" [formControl]="ownerControl">
      <input type="hidden" [formControl]="partnerControl">
      <input type="hidden" [formControl]="ofwcaControl">
    </ng-container>

  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <ng-container ><button (click)="sendForm()" [class.spinner]="processingRequest" [disabled]="processingRequest || !enableSaveButton" mat-stroked-button color="primary" ><mat-icon>save</mat-icon> <span> Zapisz</span></button></ng-container>
<!--    <ng-container *ngIf="contractForm.get('partner').value && contractType?.key === CONTRACT_TYPE_SELF_BILLING && !getListOfVatButton"><button (click)="getListOfVat()"  mat-stroked-button color="primary" matTooltip="Wykaz Podatnikow Vat" class="active"><mat-icon>send</mat-icon><span> Pobierz dane z rejestru podatników VAT</span></button></ng-container>-->
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
